import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';
import { userRoleNameEnum } from '../const/enum';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard {
  constructor(
    private router: Router,
    private utilService: UtilService
  ) { }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let data = this.utilService.loginUserType;
    if (data === userRoleNameEnum.superAdmin || data === userRoleNameEnum.manager || data === userRoleNameEnum.IT || userRoleNameEnum.operator) {
      return true;
    }
    if (data === userRoleNameEnum.clientSupport) {
      this.router.navigate(['/client-support/dashboard']);
      return false;
    }
    this.router.navigate(['/new-dashboard']);
    return false;
  }
}
